/**
 * katPreference (HOF-101) — the last selected Preisspiegel Kategorie, remembered
 * per tenant in `localStorage`.
 *
 * HOF-106 moved the mechanics — the per-tenant key template and the two
 * try/catch blocks — into {@link ../../../utils/lensPreference}, where /farm,
 * /documents and Ernteprognose now share them. The behaviour, the key prefix and
 * the exported names are unchanged; `__tests__/katPreference.test.ts` is
 * untouched and still owns the proof. Read that module for the *why* of
 * `localStorage`, of the per-tenant key, and of guarding every access.
 *
 * Deliberately NOT validated here: whether the stored id names a Kategorie this
 * tenant has data for. That is `resolveSelectedKategorie`'s job (#2420 — the
 * lens renders only the data-bearing subtree), and duplicating it here would
 * give two places that can disagree about what a valid lens is.
 */
import { createLensPreference } from '../../../utils/lensPreference';

/** Key prefix; the tenant id is appended. */
export const KAT_PREFERENCE_LS_PREFIX = 'hofsync.preisspiegel.kat';

const preference = createLensPreference(KAT_PREFERENCE_LS_PREFIX);

/** The storage key for a tenant, or null when there is no tenant to key by. */
export const katPreferenceKey = preference.key;

/** The stored Kategorie id for a tenant, or null (no tenant / none stored / storage unusable). */
export const readStoredKategorie = preference.read;

/** Remember a tenant's Kategorie. A no-op without a tenant, or when storage refuses. */
export const writeStoredKategorie = preference.write;
